import type { ButtonHTMLAttributes, MouseEvent, ReactNode } from "react";
import styles from "./ListItem.module.css";
import { cx } from "../cx";
import { IconArrowUpRightLine, IconChevronRightLine } from "../icons/Icon";
import { Switch } from "../components/Switch";

export type ListItemProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children" | "title"> & {
  prefixIcon?: ReactNode;
  title: ReactNode;
  detail?: ReactNode;
  /** external = 외부 링크(약관 등), ArrowUpRight 아이콘 */
  suffix?: "none" | "chevron" | "external" | { switch: boolean; onSwitch: (v: boolean) => void };
};

/** SEED ListItem (Figma 97:3813). 설정 화면 행. */
export function ListItem({ prefixIcon, title, detail, suffix = "chevron", className, onClick, ...rest }: ListItemProps) {
  const isSwitch = typeof suffix === "object";
  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (isSwitch) suffix.onSwitch(!suffix.switch);
    onClick?.(e);
  };
  // 스위치 행은 <button> 중첩을 피하려고 div[role=switch]로 렌더링하고, 내부 Switch는 표시 전용이다.
  const Root = (isSwitch ? "div" : "button") as "button";
  const a11y = isSwitch ? { role: "switch", "aria-checked": suffix.switch, tabIndex: 0 } : { type: "button" as const };
  return (
    <Root {...a11y} className={cx(styles.root, className)} onClick={handleClick} {...rest}>
      {prefixIcon && <span className={styles.icon}>{prefixIcon}</span>}
      <span className={styles.title}>{title}</span>
      {detail && <span className={styles.detail}>{detail}</span>}
      {suffix === "chevron" && <IconChevronRightLine size={16} className={styles.chevron} />}
      {suffix === "external" && <IconArrowUpRightLine size={16} className={styles.chevron} />}
      {isSwitch && <Switch checked={suffix.switch} onCheckedChange={() => {}} tabIndex={-1} aria-hidden style={{ pointerEvents: "none" }} />}
    </Root>
  );
}
